import React, { useState, useEffect } from 'react';
import axios from 'axios';

const VideoGallery = () => {
  const [data, setData] = useState([
    {
      img: 'https://i.ytimg.com/vi/kWbHSVROo5Y/mqdefault.jpg',
      video: 'https://www.youtube.com/watch?v=kWbHSVROo5Y&embeds_referring_euri=https%3A%2F%2Fytjobs.co%2F&source_ve_path=OTY3MTQ&feature=emb_imp_woyt',
    },
    {
      img: 'https://i.ytimg.com/vi/W7h3PtSG1zg/mqdefault.jpg',
      video: 'https://www.youtube.com/watch?v=W7h3PtSG1zg&embeds_referring_euri=https%3A%2F%2Fytjobs.co%2F&source_ve_path=OTY3MTQ&feature=emb_imp_woyt',
    },
    {
      img: 'https://i.ytimg.com/vi/5dq5yo31uWU/mqdefault.jpg',
      video: 'https://www.youtube.com/watch?v=5dq5yo31uWU&embeds_referring_euri=https%3A%2F%2Fytjobs.co%2F&source_ve_path=OTY3MTQ&feature=emb_imp_woyt',
    },
    {
      img: 'https://i.ytimg.com/vi/pN0YH74YL24/mqdefault.jpg',
      video: 'https://www.youtube.com/watch?v=pN0YH74YL24&embeds_referring_euri=https%3A%2F%2Fytjobs.co%2F&source_ve_path=OTY3MTQ&feature=emb_imp_woyt',
    },
    {
      img: 'https://i.ytimg.com/vi/pD9E8EuCYCQ/mqdefault.jpg',
      video: 'https://www.youtube.com/watch?v=pD9E8EuCYCQ&embeds_referring_euri=https%3A%2F%2Fytjobs.co%2F&source_ve_path=OTY3MTQ&feature=emb_imp_woyt',
    },
    {
      img: 'https://i.ytimg.com/vi/QC7aHBpeiDI/mqdefault.jpg',
      video: 'https://www.youtube.com/watch?v=QC7aHBpeiDI&embeds_referring_euri=https%3A%2F%2Fytjobs.co%2F&source_ve_path=OTY3MTQ&feature=emb_imp_woyt',
    },
    {
      img: 'https://i.ytimg.com/vi/5jm10Mpl8hE/mqdefault.jpg',
      video: 'https://www.youtube.com/watch?v=5jm10Mpl8hE&embeds_referring_euri=https%3A%2F%2Fytjobs.co%2F&source_ve_path=OTY3MTQ&feature=emb_imp_woyt',
    },
    {
      img: 'https://i.ytimg.com/vi/6AcHY-V6O54/mqdefault.jpg',
      video: 'https://www.youtube.com/watch?v=6AcHY-V6O54&embeds_referring_euri=https%3A%2F%2Fytjobs.co%2F&source_ve_path=OTY3MTQ&feature=emb_imp_woyt',
    },
    {
      img: 'https://i.ytimg.com/vi/DD7aTBCdls0/mqdefault.jpg',
      video: 'https://www.youtube.com/watch?v=DD7aTBCdls0&embeds_referring_euri=https%3A%2F%2Fytjobs.co%2F&source_ve_path=OTY3MTQ&feature=emb_imp_woyt',
    },
    {
      img: 'https://i.ytimg.com/vi/K1xcpcTMawM/mqdefault.jpg',
      video: 'https://www.youtube.com/watch?v=K1xcpcTMawM&embeds_referring_euri=https%3A%2F%2Fytjobs.co%2F&source_ve_path=OTY3MTQ&feature=emb_imp_woyt',
    },
  ]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('https://clientserver-production-f8b8.up.railway.app/api/videos?populate=*');
        const apiData = response.data.data;

        const transformedData = apiData.map(item => ({
          img: 'https://clientserver-production-f8b8.up.railway.app' + item.attributes.image.data.attributes.formats.thumbnail.url,
          video: item.attributes.Lien,
        }));

        setData(prevData => {
          // Check if the data already exists
          const newEntries = transformedData.filter(
            newItem => !prevData.some(item => item.img === newItem.img && item.video === newItem.video)
          );
          return [...prevData, ...newEntries];
        });
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className='flex justify-center items-center flex-col mt-[200px]'>
      <div className='mb-[50px]'>
        <p className='text-border text-[#C0392B] text-lg text-center md:text-5xl uppercase border-2 border-[#C0392B] rounded-lg shadow-[#C0392B] shadow-lg p-2'>
          Our recent projects on VideoEditing
        </p>
      </div>
      <div className="flex flex-col items-center" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 p-4">
          {data.map((item, index) => (
            <div
              key={index}
              className="max-w-[800px] bg-black p-4 rounded-lg shadow-md cursor-pointer border border-[#C0392B]"
            >
              <img src={item.img} alt={`Image ${index + 1}`} className="rounded-lg w-[430px]" />
              <div className="mt-2 flex justify-center">
                <a
                  href={item.video}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 bg-[#C0392B] md:text-lg rounded-full text-black hover:bg-[#C0392B] transition-colors duration-300 ease-in-out"
                >
                  Watch Video
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VideoGallery;
